import Combobox from "@/components/custom/Combobox";
import { crmRegistry } from "../../../lib/_core/crmRegistry";
import { SelectCrmSystemComboboxProps } from ".";

export function SelectCrmSystemCombobox({mode, ...props}: Readonly<SelectCrmSystemComboboxProps>) {
    const items = crmRegistry.getSystemsList().map(system=>({
        label: system.name,
        value: system.id
    }))
    return (
        <Combobox
            {...props}
            mode={mode}
            triggerLabel={mode === 'multiple' ? 'Select CRM Systems' : 'Select CRM System'}
            items={items}
        />
    )
}